import { Component } from "react";

import "./style.scss";
class TitleSeparator extends Component {
    render() {
        return (
            <>
                <div className="title-separator"><span>{this.props.title}</span></div>
            </>
        )
    }
}

export default TitleSeparator;